import { NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { HealthCheckService } from '@rspl-api';
import { FxLayoutAlignDirective, FxLayoutDirective } from '@rspl-ui';

import { FxLayoutGapDirective } from '../flex-layout/fx-layout-gap.directive';

@Component({
  selector: 'rspl-health-check',
  templateUrl: './health-check.component.html',
  styleUrls: ['./health-check.component.scss'],
  imports: [FxLayoutDirective, FxLayoutAlignDirective, FxLayoutGapDirective, NgClass],
})
export class HealthCheckComponent implements OnInit {
  public upAndRunning!: boolean;

  constructor(private service: HealthCheckService) {}

  ngOnInit(): void {
    this.service.healthCheck().subscribe({
      next: () => {
        this.upAndRunning = true;
      },
      error: () => {
        this.upAndRunning = false;
      },
    });
  }
}
